import React, { useState } from "react";
import styles from "./styles.module.scss";

function Jack6SeatCouch() {
  const [selectedImage, setSelectedImage] = useState(
    "https://advertflair-public.s3.us-west-2.amazonaws.com/client/urbanoutfitters/jack-6seat-couch/thumbnail3.jpg"
  );
  const [imageContainer, setImageContainer] = useState(true);
  const [glbContainer, setGlbContainer] = useState(false);
  const [tryonContainer, setTryonContainer] = useState(false);
  const [touchableGlbContainer, setTouchableGlbContainer] = useState(false);

  const handleImageClick = (imageSrc) => {
    setGlbContainer(false);
    setSelectedImage(imageSrc);
    setImageContainer(true);
    setTryonContainer(false);
    setTouchableGlbContainer(false);
  };

  const toggleGlb = () => {
    setGlbContainer(true);
    setImageContainer(false);
    setTryonContainer(false);
    setTouchableGlbContainer(false);
  };

  const tryonGlb = () => {
    setGlbContainer(false);
    setImageContainer(false);
    setTryonContainer(true);
    setTouchableGlbContainer(false);
  };

  const toggletouchableGlb = () => {
    setGlbContainer(false);
    setImageContainer(false);
    setTryonContainer(false);
    setTouchableGlbContainer(true);
  };

  return (
    <div>
      <div className={styles.container}>
        <img
          src="https://advertflair-public.s3.us-west-2.amazonaws.com/client/anthropologie/dowel-counter-stool/header.webp"
          alt=""
        />

        <div className={styles.mainSection}>
          <div className={styles.leftSection}>
            <div className={styles.renderSection}>
              <div className={styles.textSection}></div>
              {imageContainer && <img src={selectedImage} alt="" />}
              {glbContainer && (
                <iframe
                  title="desktopGlb"
                  seamless
                  src="https://www.pod.advflr.com/turnaround/urbanoutfitters/6-seat-couch"
                ></iframe>
              )}

              {tryonContainer && (
                <iframe
                  title="desktopGlb"
                  seamless
                  allow="camera"
                  src="https://www.watchsdk.advflr.com/?glb=https://advertflair-public.s3.us-west-2.amazonaws.com/client/rado/output/rado-mens-watch-ar.glb"
                ></iframe>
              )}

              {touchableGlbContainer && (
                <iframe
                  title="desktopGlb"
                  seamless
                  allow="camera"
                  src="https://app.vectary.com/p/29nqAVVHR8Fe2ekgE6v6MK"
                ></iframe>
              )}
            </div>

            <div className={styles.thumbnailSection}>
              <img
                src="https://advertflair-public.s3.us-west-2.amazonaws.com/client/urbanoutfitters/jack-6seat-couch/thumbnail1.jpg"
                onClick={() =>
                  handleImageClick(
                    "https://advertflair-public.s3.us-west-2.amazonaws.com/client/urbanoutfitters/jack-6seat-couch/thumbnail1.jpg"
                  )
                }
              />
              <img
                src="https://advertflair-public.s3.us-west-2.amazonaws.com/client/urbanoutfitters/jack-6seat-couch/thumbnail2.jpg"
                onClick={() =>
                  handleImageClick(
                    "https://advertflair-public.s3.us-west-2.amazonaws.com/client/urbanoutfitters/jack-6seat-couch/thumbnail2.jpg"
                  )
                }
              />
              <img
                src="https://advertflair-public.s3.us-west-2.amazonaws.com/client/urbanoutfitters/jack-6seat-couch/thumbnail3.jpg"
                onClick={() =>
                  handleImageClick(
                    "https://advertflair-public.s3.us-west-2.amazonaws.com/client/urbanoutfitters/jack-6seat-couch/thumbnail3.jpg"
                  )
                }
              />
              <img
                src="https://advertflair-public.s3.us-west-2.amazonaws.com/client/stojo/cup/366-1.webp"
                onClick={toggleGlb}
              />
              <img
                src="https://advertflair-public.s3.us-west-2.amazonaws.com/client/belkin/earbuds/touch_view.webp"
                onClick={toggletouchableGlb}
              />
            </div>
          </div>
          <div className={styles.rightSection}>
            <h1>
              JACH 138" Black Sectional Couches, U-Shaped Minimalist Velvet
              Sofas, Convertible Modular Sofa, Luxury Modern 6-Seats Couch
              Sectional with Chaise Ottomans for Living Room
            </h1>
            <p>See all JACH</p>
            <h1>$1199.00</h1>

            <button>Add to Bag</button>

            <p> Or 4 interest-free installments of $25.00 with or </p>
          </div>
        </div>

        <div className={styles.footerSection}>
          <img
            src="https://advertflair-public.s3.us-west-2.amazonaws.com/client/anthropologie/dowel-counter-stool/footer.webp"
            alt=""
          />
        </div>
      </div>
      <div className={styles.mobileContainer}>
        <img
          src="https://advertflair-public.s3.us-west-2.amazonaws.com/client/anthropologie/dowel-counter-stool/mobile_header.webp"
          alt=""
        />

        <div className={styles.mainSection}>
          <div className={styles.renderSection}>
            <div className={styles.textSection}></div>
            {imageContainer && <img src={selectedImage} alt="" />}
            {glbContainer && (
              <iframe
                title="desktopGlb"
                seamless
                src="https://www.pod.advflr.com/turnaround/urbanoutfitters/6-seat-couch"
              ></iframe>
            )}

            {tryonContainer && (
              <iframe
                title="desktopGlb"
                seamless
                allow="camera"
                src="https://www.watchsdk.advflr.com/?glb=https://advertflair-public.s3.us-west-2.amazonaws.com/client/rado/output/rado-mens-watch-ar.glb"
              ></iframe>
            )}

            {touchableGlbContainer && (
              <iframe
                title="desktopGlb"
                seamless
                allow="camera"
                src="https://app.vectary.com/p/29nqAVVHR8Fe2ekgE6v6MK"
              ></iframe>
            )}
          </div>

          <div className={styles.thumbnailSection}>
            <img
              src="https://advertflair-public.s3.us-west-2.amazonaws.com/client/urbanoutfitters/jack-6seat-couch/thumbnail1.jpg"
              onClick={() =>
                handleImageClick(
                  "https://advertflair-public.s3.us-west-2.amazonaws.com/client/urbanoutfitters/jack-6seat-couch/thumbnail1.jpg"
                )
              }
            />
            <img
              src="https://advertflair-public.s3.us-west-2.amazonaws.com/client/urbanoutfitters/jack-6seat-couch/thumbnail2.jpg"
              onClick={() =>
                handleImageClick(
                  "https://advertflair-public.s3.us-west-2.amazonaws.com/client/urbanoutfitters/jack-6seat-couch/thumbnail2.jpg"
                )
              }
            />
            <img
              src="https://advertflair-public.s3.us-west-2.amazonaws.com/client/urbanoutfitters/jack-6seat-couch/thumbnail3.jpg"
              onClick={() =>
                handleImageClick(
                  "https://advertflair-public.s3.us-west-2.amazonaws.com/client/urbanoutfitters/jack-6seat-couch/thumbnail3.jpg"
                )
              }
            />
            <img
              src="https://advertflair-public.s3.us-west-2.amazonaws.com/client/stojo/cup/366-1.webp"
              onClick={toggleGlb}
            />
            <img
              src="https://advertflair-public.s3.us-west-2.amazonaws.com/client/belkin/earbuds/touch_view.webp"
              onClick={toggletouchableGlb}
            />
          </div>
        </div>

        <div className={styles.contentSection}>
          <h1>
            JACH 138" Black Sectional Couches, U-Shaped Minimalist Velvet Sofas,
            Convertible Modular Sofa, Luxury Modern 6-Seats Couch Sectional with
            Chaise Ottomans for Living Room
          </h1>
          <p>See all JACH</p>
          <h1>$1199.00</h1>

          <button>Add to Bag</button>

          <p> Or 4 interest-free installments of $257.00 </p>
        </div>

        <div className={styles.footerSection}>
          <img
            src="https://advertflair-public.s3.us-west-2.amazonaws.com/client/anthropologie/dowel-counter-stool/mobile_footer.webp"
            alt=""
          />
        </div>
      </div>
    </div>
  );
}

export default Jack6SeatCouch;
